'use strict';
var novicell = novicell || {};

novicell.navigation = novicell.navigation || function () {

	function init() {
		var header_action = document.querySelectorAll('.js-header-action');

		if ( header_action ) {
			header_actions(header_action);
		} 

		//sub_menu_toggle();
	}

	function header_actions(actions) {
		var site = document.getElementById('js-site');

		for (var i = 0; i < actions.length; i++) {
			let action = actions[i];

			action.addEventListener('click', function(e) {
				e.stopPropagation();

				let type = this.getAttribute('data-header-action');

				( type == 'site-nav' )
					? site_nav(type, site)
					: site_search(type, site);
			});
		}
	}

	function site_nav(type, site) {
		const site_nav 		= document.getElementById('js-site-nav'),
			  nav_items 	= site_nav.querySelectorAll('ul > li:not(.current-menu-item)');

		var i = 0;

		if ( !site.classList.contains('site-nav-active') ) {

			bodyScrollLock.clearAllBodyScrollLocks();
			bodyScrollLock.disableBodyScroll(site_nav);

			site.classList.add('site-nav-active');
			site.classList.remove('site-search-active');

			function nav_item_timeout(i) {
				setTimeout(function() {
					nav_items[i].classList.add('visible');
				}, i*50);
			}

			function nav_timeout(i) {
				setTimeout(function() {
					nav_item_timeout(i)
				}, 250);
			}

			for (i = 0; i < nav_items.length; i++) { 
				nav_timeout(i);
			}
		} else {
			site.classList.remove('site-nav-active');
			site.classList.remove('site-search-active');

			function nav_item_timeout(i) {
				setTimeout(function() {
					nav_items[i].classList.remove('visible');
				}, i*50);
			}

			for (i = 0; i < nav_items.length; i++) { 
				nav_item_timeout(i);
			}

			bodyScrollLock.clearAllBodyScrollLocks();
		}
	}

	function site_search(type, site) {
		const search_input = document.querySelector('.site-search__input');

		if ( !site.classList.contains('site-search-active') ) {
			site.classList.add('site-search-active');

			setTimeout(function() {
				search_input.focus();
			}, 400);
		} else {
			site.classList.remove('site-search-active');
		}
	}

	// function sub_menu_toggle() {
	// 	var site_nav = document.getElementById('js-site-nav'),
	// 		site_nav_item = site_nav.getElementsByClassName('menu-item-has-children');

	// 	for (var i = 0; i < site_nav_item.length; i++) {
	// 		var sub_menu_toggle = site_nav_item[i].querySelector('.js-sub-menu-toggle-btn');

	// 		sub_menu_toggle.addEventListener('click', function() {
	// 			var nav_item = this.parentElement,
	// 				sub_menu = nav_item.querySelector('.sub-menu');

	// 			if ( !nav_item.classList.contains('open') ) {
	// 				sub_menu.style.height = '100%';
	// 				var height = sub_menu.scrollHeight + 'px';
	// 				sub_menu.style.height = '';

	// 				sub_menu.style.height = height;
	// 				nav_item.classList.add('open');
	// 			} else {
	// 				sub_menu.style.height = '0px';
	// 				nav_item.classList.remove('open');
	// 			}

	// 		});
	// 	}
	// }

	return {
		init : init
	};

}();